// extracted by mini-css-extract-plugin
export default {"msg":"Msg_msg__dAgKz"};